// src/constants/pricing.js (sanoire-admin)
//
// The two Passage plans, identical to sanoire-native src/constants/pricing.js.
// Passage is sold only through Google Play (28 Sep 2026); there is no other
// plan. Revenue figures here are LIST prices: a new member on the launch offer
// pays LAUNCH_OFFER.price for LAUNCH_OFFER.cycles months, and Play charges
// local prices outside the US, so the true amounts are in Play Console.

export const PASSAGE_PRICES = { MONTHLY: 15, ANNUAL: 129 };
export const PASSAGE_LABELS = { MONTHLY: 'Monthly', ANNUAL: 'Annual' };
export const LAUNCH_OFFER = { price: 10, cycles: 12, availableUntil: '2027-12-31' };
export const MONTHLY_PRICE = PASSAGE_PRICES.MONTHLY;
export const PLAY_CONSOLE_URL = 'https://play.google.com/console';

// RevenueCat writes 'monthly' / 'annual'; older rows are upper-case.
export function planKey(passType) {
  const k = String(passType || '').toUpperCase();
  return k === 'MONTHLY' || k === 'ANNUAL' ? k : null;
}
export function priceOf(passType) {
  const k = planKey(passType);
  return k ? PASSAGE_PRICES[k] : 0;
}
